import { action, computed, makeObservable, observable } from 'mobx';
import client from '~/services/client';
import logger from '~/services/logger';
import { LoadingStatus } from '~/types/main';

export interface IResponseConfigDook {
  images: {
    dook_banner: string | null;
    dook_banner_md: string | null;
  };
}

type Config = {
  bannerImage: string;
  bannerImageMd: string;
};

const defaultConfig = { bannerImage: '', bannerImageMd: '' };

class DookConfigStore {
  constructor() {
    makeObservable(this);
  }

  private _loadedConfig: Config = defaultConfig;

  @observable config: Config = defaultConfig;
  @observable validation: { isValidBannerImage: boolean } = { isValidBannerImage: true };
  @observable isEdited: boolean = false;
  @observable loading: LoadingStatus = LoadingStatus.Init;

  @computed get isValid() {
    return Object.values(this.validation).every(Boolean);
  }

  @action changeImage = (images: Partial<Config>) => {
    this.config = { ...this.config, ...images };
    this.isEdited = true;
    if (!this.validation.isValidBannerImage) this.setValidation();
  };

  @action setData = (data: IResponseConfigDook) => {
    this._loadedConfig = { bannerImage: data.images.dook_banner || '', bannerImageMd: data.images.dook_banner_md || '' };
    this.config = this._loadedConfig;
  };

  @action setValidation = () => {
    this.validation.isValidBannerImage = this.config.bannerImage ? true : false;
  };

  @action updateConfig = async () => {
    try {
      this.loading = LoadingStatus.Loading;

      await client.put('v3/settings/consumer-channels/dook', {
        dook_banner: this.config.bannerImage,
        dook_banner_md: this.config.bannerImageMd,
      });
      this._loadedConfig = this.config;

      this.isEdited = false;
      this.loading = LoadingStatus.Success;
    } catch (error: any) {
      this.loading = LoadingStatus.Error;
      logger.error({ error, place: 'DookConfigChange updateConfig', showModal: true });
    }
  };

  @action clear = () => {
    this.isEdited = false;
    this.config = this._loadedConfig;
    this.validation = { isValidBannerImage: true };
  };
}

const dookConfigStore = new DookConfigStore();

export default dookConfigStore;
